import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { UsuarioAdminLoginResponse } from '../services/responses/usuario-admin/usuario-admin-login.response';

@Directive({
  selector: '[appTemPermissao]',
})
export class TemPermissaoDirective implements OnInit {
  @Input('appTemPermissao') permissaoId: number = 0;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const objToken = sessionStorage.getItem('token');
    let temPermissao = false;

    if (objToken) {
      const token: UsuarioAdminLoginResponse = JSON.parse(objToken);
      const listaPermissoes: number[] = token?.listaPermissoes || [];
      temPermissao = token.master || listaPermissoes.includes(this.permissaoId);
    }

    const view = this.viewContainer.createEmbeddedView(this.templateRef);
    // Marca os elementos do template com atributo 'disabled-permission' se não tiver permissão
    if (!temPermissao) {
      view.rootNodes.forEach(el => {
        if (el instanceof HTMLElement) {
          el.setAttribute('title', 'Você não tem permissão para usar esta funcionalidade');
          el.setAttribute('data-disabled-permission', 'true');
          el.style.opacity = '0.6';
          el.style.cursor = 'default';

          if ('disabled' in el) {
            (el as HTMLButtonElement | HTMLInputElement).disabled = true;
          }

          el.addEventListener(
            'click',
            event => {
              event.preventDefault();
              event.stopImmediatePropagation();
            },
            true
          );
        }
      });
    }
  }
}
